<!-- <app-home></app-home> -->
<router-outlet class="bg"></router-outlet>